import { render, staticRenderFns } from "./setUserInfo.vue?vue&type=template&id=00a2f468&scoped=true&"
import script from "./setUserInfo.vue?vue&type=script&lang=js&"
export * from "./setUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a2f468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a2f468')) {
      api.createRecord('00a2f468', component.options)
    } else {
      api.reload('00a2f468', component.options)
    }
    module.hot.accept("./setUserInfo.vue?vue&type=template&id=00a2f468&scoped=true&", function () {
      api.rerender('00a2f468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setUserInfo.vue"
export default component.exports